import { useLookupContentByUrlLazyQuery } from 'constants/graphqlTypes';

export interface ICanonicalLookupData {
  canonicalTitle?: string | null;
  canonicalImageUrl?: string | null;
  canonicalCreatorNames?: string[] | null;
  canonicalMediaTagName?: string | null;
}

export const useCanonicalLookup = () => {
  const [query, { data, loading }] = useLookupContentByUrlLazyQuery();

  const lookup = (url: string) => query({ variables: { url } });

  const canonical = data?.lookupContentByUrl;
  const lookupData: ICanonicalLookupData | null = canonical
    ? {
        canonicalTitle: canonical.title,
        canonicalImageUrl: canonical.imageUrl,
        canonicalCreatorNames: canonical.creatorNames as string[] | null,
        canonicalMediaTagName: canonical.mediaTagName,
      }
    : null;

  return { lookup, lookupData, loading };
};
